<template>
  <button
    type="button"
    class="flex items-center justify-between"
    @click="onCopyBookingNumber"
  >
    <slot />

    <slot name="icon">
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" class="fill-current" width="24" height="24" fill="none"><path fill-rule="evenodd" d="M7 14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v8Zm3 1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8Z" clip-rule="evenodd"/><path d="M3 17.214A3.786 3.786 0 0 0 6.786 21H14a1 1 0 1 0 0-2H6.786C5.799 19 5 18.2 5 17.214V10a1 1 0 1 0-2 0v7.214Z"/></svg>
    </slot>
  </button>
</template>

<script setup lang="ts">
  // @ts-expect-error Library does not have type declarations
  import { copyText } from '@aviata/copy-text';

  const props = defineProps<{ text: string }>();

  const emit = defineEmits<{ onCopy: [] }>();

  const onCopyBookingNumber = () => {
    copyText(props.text).then(() => emit('onCopy'));
  };
</script>
